import NotFound from '@Pages/NotFound/NotFound.tsx';
import { useUser } from '@kg-internal/pv3-uikit';
import { type JSX } from 'react';

export const PrivateRoute = ({
  children,
  roles,
  redirect = <NotFound />,
}: {
  children: JSX.Element;
  roles: string | string[];
  redirect?: JSX.Element;
}) => {
  const user = useUser();

  return user.hasPermissions(roles) ? children : redirect;
};
